<template>
  <ClientRegionReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Mapper from "@/mappers"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import ClientRegionReport from "@/components/report/ClientStatistics/ClientsReportComponent.vue";

export default {
  name: "ClientRegionReportView",
  components: {
    ClientRegionReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedFilters, selectedClients, type} = filters;
      if (selectedFilters && selectedFilters.includes(3) && !selectedFilters.includes(2)) {
        selectedFilters.push(2);
      }

      this.$store.dispatch(LAYOUT_LOADING_START)

      ReportService.getClientReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedClients: selectedClients ? selectedClients : null,
        type: type
      }).then(response => {
        this.items = _.map(response.data, rvm => {
          return {
            client: Mapper.mapClient(rvm.Client),
            received: rvm.Received,
            printedForPeriodNormal: rvm.PrintedForPeriodNormal,
            restForPeriodEnd: selectedFilters ?
                (rvm.Received !== null && rvm.PrintedForPeriodNormal !== null ?
                    (rvm.Received - rvm.PrintedForPeriodNormal) : null) : null,
            deletedFromPostPackageCount: rvm.DeletedFromPostPackageCount,
            postPackedForPeriod: rvm.PostPackedForPeriod,
            deliveredFromPacked: rvm.DeliveredFromPacked,
            returnedFromPacked: rvm.ReturnedFromPacked,
            tryPerform: rvm.TryPerformCount,
            postPackedNotPerformed: rvm.PostPackedNotPerformed,
          }
        })
      })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics)
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика по организациям")
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>